import axios from 'axios'
import convertToSnakeCase from '@Utils/ConvertToSnakeCase'

import {
  ICancelSubscriptionPayload,
  IStartCheckoutSessionPayload,
  IUpdateSubscriptionPayload,
} from './types'

export function cancelSubscription(data: ICancelSubscriptionPayload) {
  return axios.delete(`/api/v1/subscriptions/cancel`, { data: convertToSnakeCase(data) })
}

export function startCheckoutSession(payload: IStartCheckoutSessionPayload) {
  return axios.post('/api/v1/subscriptions/start_checkout_session', convertToSnakeCase(payload))
}

export function updateSubscription(payload: IUpdateSubscriptionPayload) {
  return axios.put(`/api/v1/subscriptions/${payload.subscriptionId}`, convertToSnakeCase(payload))
}
